export default {
  name: "Faq",
  path: "/faq",
  component: () => import("@/views/Faq")
};
